export enum CCProcessors {
	SHIFT4 = 1,
	AUTHNET = 2,
	POS = 3,
	FOCUSPAYADYEN = 4,
	FOCUSPAYDATACAP = 5,
}
